import { styled, theme } from '@clickcease/cc-client-components-lib'

const {
  space: {
    16: { value: space16 },
  },
} = theme

export const DataUsageWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '920px',
  '*': {
    lineHeight: 1,
  },
})

export const DataUsageTitle = styled('div', {
  margin: '$10 0',
  fontWeight: '$sb',
  fontSize: '$lg',
})

export const ProductsWrapper = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
  gridTemplateRows: '400px',
  gap: '$10',
  width: '100%',
  color: '$black',
})

export const LoaderContainer = styled('div', {
  display: 'flex',
  justifyContent: 'left',
  margin: '$8',

  '> svg': {
    height: space16,
  },
})
